import { Box } from '@mui/material';
import './Logo.css';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
}

export function Logo({ size = 'medium' }: LogoProps) {
  return (
    <Box 
      component="img"
      src="https://www.cholainsurance.com/o/chola-corporate-theme/images/logo.png"
      alt="Chola Insurance"
      sx={{
        height: size === 'small' ? '40px' : size === 'medium' ? '50px' : '60px',
        width: 'auto',
        objectFit: 'contain'
      }}
    />
    
    
  );
}